import { useContext, useEffect } from 'react'
import { ModalContext } from '@nv/contexts'
import { PrinterLgIcon } from '@nv/images/design/printer-lg-icon'
import { ServerIcon } from '@nv/images/design/server-icon'
import { useTranslation } from 'react-i18next'
import styles from './SendJobProgress.module.scss'

export const SendJobProgress = () => {
  const { t } = useTranslation()
  const { setHeaderLabel } = useContext(ModalContext)

  useEffect(() => {
    setHeaderLabel(t('Send Test Job'))
  }, [])

  return (
    <div className={styles['container']}>
      <div className={styles['progress__container']}>
        <ServerIcon />
        <div className={styles['connector']}>
          <div className={styles['dot']}></div>
          <div className={styles['dot']}></div>
          <div className={styles['dot']}></div>
          <div className={styles['dot']}></div>
        </div>
        <PrinterLgIcon />
      </div>

      <div className={styles['message']}>
        <p>
          Sending job to the printer.
          <br />
          Please do not close this window
        </p>
      </div>
    </div>
  )
}
